var addHistory = angular.module('addHistory', ['classy']);

addHistory.classy.controller({
    name: 'AddHistoryController',
    inject: ['$scope', '$timeout', 'authServiceFactory', 'ApplicationService', 'AddHistoryService', '$modalInstance',
        'standardCudArrayFactory', 'PreFastHistoryService', 'HistoryDataModelService', 'index', 'history'],
    init: function() {

        this.$.$modalInstance = this.$modalInstance;

        if (this.index === undefined) {
            let applicants = [];
            angular.forEach(this.ApplicationService.getAwardData().applicants, (value, key) => {
                let applicant = this.newApplicant();
                applicant.App_Name = value.App_First + " " + value.App_Last;
                applicants.push(applicant);
            });
            this.$.items = {
                preFast: true,
                applicants: applicants,
                income: 0,
                tuition: 0,
                taxes: 0
            };
        } else {
            this.$.items = this.history.data[this.index];
            this.$.items.preFast = true;
            this.$.items.AppFinYear = this.$.items.applicants[0].AppFinYear;
            this.$.items.income = this.$.items[0].income;
            this.$.items.tuition = this.$.items[0].tuition;
            this.$.items.taxes = this.$.items[0].taxes;
        }

    },
    newApplicant: function() {
        return {
            App_Name: null,
            ActAward: null,
            AppFinYear: null,
            schoolID: this.authServiceFactory.getAuth().schoolID
        };
    },
    addApplicant: function()
    {
        this.$.items.applicants.push(this.newApplicant());
    },
    remove: function(index)
    {
        // if applicant has a recordID (exists in db)
        if (this.$.items.applicants[index].recordID) 
            this.$.items.applicants[index].delete = 1;
        else // applicant does not exist in db
            this.$.items.applicants.splice(index, 1);
    },
    startSaveProcess: function(scope, instance, form) {
        let putObject = angular.copy(this.$.items);
        if (form.$valid) {
            instance.options.factor  = .3;
            this.PreFastHistoryService.post(this.ApplicationService.getAwardData().app[0].applicationID,
                putObject, instance);
        }
    },
    successSave: function(scope, instance)
    {
        this.$.$modalInstance.close(true);
    }
});

addHistory.factory('AddHistoryService', function($modal, $http, ApplicationService){
    var initModal = function (items, index) {
        return $modal.open({
            templateUrl: 'fast/submodules/schoolside/applications/submodules/tabs/submodules/history/partials/addHistoryModal.html?v=' + versionNo,
            controller: 'AddHistoryController',
            resolve:
            {
                index: function() {
                    return index;
                },
                history: function() {
                    return $http.get('/api/family/'+ApplicationService.getFamilyData().data[0].familyID+'/historyData')
                }
            }
        });
    };
    return {
        initModal: initModal
    }
});